var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowDoubleDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 72,
    viewBox: "0 0 24 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9393 71.0607C11.5251 71.6464 12.4749 71.6464 13.0607 71.0607L22.6066 61.5147C23.1924 60.9289 23.1924 59.9792 22.6066 59.3934C22.0208 58.8076 21.0711 58.8076 20.4853 59.3934L12 67.8787L3.51472 59.3934C2.92893 58.8076 1.97918 58.8076 1.3934 59.3934C0.807609 59.9792 0.807609 60.9289 1.3934 61.5147L10.9393 71.0607ZM10.5 -6.55671e-08L10.5 70L13.5 70L13.5 6.55671e-08L10.5 -6.55671e-08Z",
    fill: "#424242"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDoubleDown);
export default __webpack_public_path__ + "static/media/arrow-double-down.60317b2d8f5cf4025dc6bf75f39909fa.svg";
export { ForwardRef as ReactComponent };